import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import MyAccountTemplate from "../../sections/my-account-template";
import MyCasesSection from "../../sections/my-cases-section";
import ViewCaseSection from "../../sections/view-case-section";
import { genrateHeadingWithFirstName } from "../../utils/myAccount";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import api from "../../utils/api";
import { useHistory } from "react-router-dom";

import "./style.scss";
import { canUseDOM } from "../../utils";

function MyAccountCases({ user, rendering, fields, lang }) {
  const {
    hero,
    accountMenu,
    myCasesTitleType,
    myCasesTitleBody,
    myCasesBody,
    noCasesTitleType,
    noCasesTitleBody,
    noCasesBody,
    viewCaseButton,
    contactUsHeadingType,
    contactUsHeadingBody,
    messageLabel,
    attachmentsLabel,
    uploadAttachmentsButton,
    validFormatsInfoText,
    submitButton,
    buttonDisclaimer,
    fileTypeNotValidText,
    fileSizeToBigErrorText,
    thankYouHeadingType,
    thankYouHeadingBody,
    thankYouBody,
    youLabel,
    phoneCallLabel
  } = fields;

  const history = useHistory();

  const phoneSvg = {
    svg:
      '<svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"/></svg>'
  };

  const casesSectionsBase = {
    heading: {
      type: myCasesTitleType,
      html: myCasesTitleBody,
      typographyClass: "type-h2"
    },
    body: { html: myCasesBody.value }
  };

  const noCase = {
    heading: {
      type: noCasesTitleType,
      html: noCasesTitleBody,
      typographyClass: "type-h4"
    },
    body: { html: noCasesBody.value }
  };

  const viewCaseSectionsBase = {
    heading: {
      type: myCasesTitleType,
      typographyClass: "type-h3"
    },

    fileTypeNotValidText,
    fileSizeToBigErrorText,
    formHeading: {
      html: contactUsHeadingBody,
      type: contactUsHeadingType,
      typographyClass: "type-h4"
    },
    messageInput: { label: messageLabel.value },
    attachFile: {
      label: attachmentsLabel.value,
      infoText: validFormatsInfoText.value,
      link: {
        ...uploadAttachmentsButton.fields,
        buttonText: uploadAttachmentsButton.fields.buttonText.value
      }
    },
    thankYouMessage: {
      heading: {
        html: thankYouHeadingBody,
        type: thankYouHeadingType,
        typographyClass: "type-h2"
      },
      body: {
        html: thankYouBody.value
      }
    },
    submitButton: {
      ...submitButton.fields,
      buttonText: submitButton.fields.buttonText.value,
      callback: (evt, data, id) => {
        sendUpdateOnCase(evt, data, id);
      }
    },
    disclaimer: buttonDisclaimer.value
  };

  const caseListViewCaseButton = {
    ...viewCaseButton.fields,
    buttonText: viewCaseButton.fields.buttonText.value
  };

  const [viewCaseId, setViewCaseId] = useState();
  const [cases, setCases] = useState();
  const [casesSections, setCasesSections] = useState(casesSectionsBase);

  const sendUpdateOnCase = async (evt, data, id) => {
    const siteRes = await api.site.get({ key: lang });
    let files = data.files.map(file => {
      let base64document = file.documentBody.split(",")[1];
      return { fileName: file.name, mimeTyoe: file.type, documentBody: base64document };
    });
    api.caseInfo
      .update(null, { customerNumber: user?.customerNumber, caseTitle: id, description: data.message, fileList: files, country: lang === "en" ? null : siteRes.CountryLocal })
      .then(res => {
        let caseData = { ...{ ...viewCaseSectionsBase, ...viewCaseId } };
        caseData.updateSentSuccessFully = true;
        let date = new Date();
        caseData.conversation = [
          {
            body: `<p>${data.message}</p>`,
            time: fomrmatTime(date.toUTCString()),
            name: youLabel.value,
            type: "message"
          },
          ...caseData.conversation
        ];
        setViewCaseId(caseData);
      })
      .catch(error => {
        console.log("failed to update order:", error);
      });
  };

  const fomrmatTime = dateString => {
    let date = new Date(dateString);
    return `${date.getHours()}:${date.getMinutes()} / ${date.toDateString()}`;
  };

  const getCase = (evt, id) => {
    let caseObj = viewCaseSectionsBase;
    let language = lang.split("-")[0];

    api.caseInfo.detail({ customerNumber: user?.customerNumber, caseTitle: id, language: language }).then(res => {
      let caseTitle = res.caseType ? `${res.caseType} - ${res.caseTitle}` : res.caseTitle;
      caseObj.id = res.caseTitle;
      caseObj.heading.html = { value: `<span>${caseTitle}</span>` };
      caseObj.description = res.description ? { value: `<p>${res.description}</p>` } : null;
      caseObj.status = res.caseStatus;
      caseObj.conversation = [];
      caseObj.caseActive = false;
      caseObj.caseClosed = true;

      res.caseInfoList.forEach(item => {
        let conversationItem;

        switch (item.activitie) {
          case "receivedEmail":
            conversationItem = {
              body: item.body && `<p>${item.body}</p>`,
              time: fomrmatTime(item.createOn),
              name: youLabel.value,
              type: "message"
            };
            break;
          case "sentEmail":
            conversationItem = {
              body: item.body && `<p>${item.body}</p>`,
              time: fomrmatTime(item.createOn),
              name: item.from,
              type: "reply"
            };
            break;
          case "phone":
            conversationItem = {
              time: fomrmatTime(item.createOn),
              label: phoneCallLabel.value,
              icon: phoneSvg,
              type: "phone"
            };
            break;
          default:
            return;
        }

        conversationItem && caseObj.conversation.push(conversationItem);
      });

      setViewCaseId(caseObj);
      if (!window.location.search) {
        let newUrl = `${window.location.href}?caseId=${caseObj.id}`;
        window.history.replaceState(null, null, newUrl);
      }
    });
  };

  const onCaseViewed = (caseId, currentStatus) => {
    if (currentStatus === "Updated") {
      api.caseInfo.changeCaseStatus(null, {
        customerNumber: user?.customerNumber,
        caseTitle: caseId,
        caseStatus: "Ongoing"
      });
    }
  };

  const getCaseList = () => {
    let language = lang.split("-")[0];
    api.caseInfo
      .list({ customerNumber: user?.customerNumber, language: language })
      .then(res => {
        if (res?.caseList === undefined || res?.caseLisit?.length === 0) {
          setCasesSections({ ...casesSectionsBase, noCase });
          return;
        }

        let _cases = [];
        res.caseList.forEach(_case => {
          let id = _case.caseTitle;
          let caseTitle = _case.caseType ? `${_case.caseType} - ${_case.caseTitle}` : _case.caseTitle;
          let data = {
            heading: {
              html: { value: `<span class="type-h4">${caseTitle} </span>` },
              type: { fields: { phrase: { value: "h4" } } }
            },
            body: {
              html: _case.description ? `<p>${_case.description}</p>` : null
            },
            id,
            link: {
              ...caseListViewCaseButton,
              callback: evt => getCase(evt, id)
            },
            status: _case.caseStatus,
            active: true,
            closed: false
          };
          _cases.push(data);
        });
        setCases(_cases);
      })
      .catch(error => {
        setCasesSections({ ...casesSectionsBase, noCase });
      });
  };

  const loadPage = () => {
    let caseId = window.location.search.split("=")[1];
    if (caseId) {
      getCase(null, caseId);
    } else {
      getCaseList();
      setViewCaseId(null);
    }
  };

  useEffect(() => {
    canUseDOM() && loadPage();
  }, []);

  useEffect(() => {
    if (canUseDOM()) {
      return history.listen(location => {
        loadPage();
      });
    }
  }, [history]);

  return (
    <div className="my-account-cases-page" datasourceid={rendering.dataSource}>
      <MyAccountTemplate
        heroConfiguration={
          hero[0].fields
            ? {
                ...hero[0].fields,
                titleBody: user ? genrateHeadingWithFirstName(hero[0].fields.titleBody, user.firstName) : ""
              }
            : {}
        }
        menu={accountMenu ? accountMenu[0].fields : {}}
      >
        <div className="my-account-cases">{viewCaseId ? <ViewCaseSection {...viewCaseId} onCaseViewed={onCaseViewed} /> : <MyCasesSection {...{ ...casesSections, cases }} />}</div>
      </MyAccountTemplate>
    </div>
  );
}

const mapStateToProps = state => ({
  user: selectUserState(state)
});

export default connect(mapStateToProps)(MyAccountCases);

MyAccountCases.propTypes = {
  heroConfiguration: PropTypes.shape({
    heading: PropTypes.shape({
      type: PropTypes.string,
      html: PropTypes.string,
      typographyClass: PropTypes.string
    }),
    overline: PropTypes.string,
    body: PropTypes.string
  }),
  menu: PropTypes.object,
  casesSections: PropTypes.object,
  viewCase: PropTypes.bool
};
